import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';
import * as T_T from 'cryface';
import { UserInfoDelegate } from '../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import { AxiosPromise } from '../../utils/axios.promise';
import { uniqBy } from 'lodash';
import * as moment from 'moment';

@Component
export default class BlogList extends Vue {
   public title: string = 'BlogList';

   public data: any[] = [];

   public configs = new CommonConfig();

   public userInfoService = new UserInfoDelegate();

   public blogTitles: string[] = [];

   @Prop()
   public page: any;

   @Prop()
   public ltype: any;

   public created() {
      // this.getBlogs();
   }

   @Prop()
   public setTotalPage: any;

   @Watch('$store.state.auth', { immediate: true, deep: true })
   public onAuthed(val: any, oldVal: any) {
      this.getBlogs();
   }

   @Watch('page', { immediate: true, deep: true })
   public async onPageChange(val: any, oldVal: any) {
      this.page = val;
      await this.getBlogs();
      // this.scrollToTop();
   }

   public async getBlogs() {
      const page = T_T.simpleDetect(this.page) ? this.page : 1;
      const ltype = T_T.simpleDetect(this.ltype) ? this.ltype : 1;
      const apiHost = this.configs.cmisapiHost;
      const user = this.userInfoService.Data;
      if (T_T.simpleDetect(user.cims_uid)) {
         const dataFetched = await AxiosPromise.get(`${apiHost}/blogArticle/pageListByUserId?userId=${user.cims_uid}&pageNum=${page}&pageSize=10&ltype=${ltype}&is_show_web=1`);
         const dataMapped: any[] = [];
         if (dataFetched.code === 200) {
            dataFetched.data.map((v: any) => {
               dataMapped.push({
                  content: T_T.trunc(v.title, 37),
                  readCount: v.readCount + v.initReadCount,
                  picture: v.images,
                  id: v.id,
                  unixFromNow: moment(v.updatedAt).fromNow(),
                  unixTimeStamp: new Date(v.updatedAt),
                  day: moment(v.updatedAt).format('DD'),
                  month: moment(v.updatedAt).format('MM'),
                  year: moment(v.updatedAt).format('YYYY'),
                  nlpTags: []
               });
               this.blogTitles.push(v.title);
            });
            this.data = dataMapped.sort((a: any, b: any) => b.unixTimeStamp - a.unixTimeStamp);
            if (T_T.simpleDetect(this.setTotalPage)) {
               this.setTotalPage(dataFetched.totalPage, dataFetched.totalRecord, dataFetched.pageSize);
            }
         } else { }
      }
      await this.decodeTags();
   }

   public onClick(id: any) {
      this.$router.push(`/blog/${id}`);
   }

   public async decodeTags() {
      const apiHost = this.configs.analysisService;
      const fetched = await AxiosPromise.postJson(`${apiHost}/nlp/chinese`, {
         strs: this.blogTitles
      });
      if (fetched.data.code === 200) {
         if (fetched.data.data.length > 0) {
            const result = uniqBy(fetched.data.data, 'text');
            this.data.map((blog: any) => {
               const nlp: any = result.find((r: any) => blog.content.trim() === r.text.trim());
               if (T_T.simpleDetect(nlp)) {
                  nlp.nlp.map((w: any) => {
                     if (w.type.includes('名词')) {
                        blog.nlpTags.push({
                           name: w.name,
                           color: 'default',
                        });
                     }
                     if (w.type.includes('其他专名')) {
                        blog.nlpTags.push({
                           name: w.name,
                           color: '#7a7a7a',
                        });
                     }
                     blog.nlpTags = uniqBy(blog.nlpTags, 'name');
                  });
               }
            });
         }
      }
      return [];
   }

   // public decodeTag(str: string) {
   //    const tags: any[] = [];
   //    this.segmentit.doSegment(str).map((v: any) => {
   //       if (Nlp.posTagger(v.p).includes('其他专名')) {
   //          tags.push({
   //             name: v.w,
   //             color: '#e51b3c'
   //          });
   //       }
   //       if (Nlp.posTagger(v.p).includes('名词')) {
   //          tags.push({
   //             name: v.w,
   //             color: '#239ebc'
   //          });
   //       }
   //    });
   //    return (tags);
   // }
}
